<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar title="Cambio" :has-back-button="true" />
      <o-message-header
        icon="check"
        text="Je cambiowagen is gereserveerd"
        :success="true"
      />
      <o-section>
        <p>
          Meer details over je reservatie vind je terug in het overzicht van je
          reservaties.
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Ga naar overzicht" to="/sales/car/cambio" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioEdit',
  components: {
    OMessageHeader,
    OPayButton
  }
}
</script>
